// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__14fOp","label":"Category_label__2ogit","content":"Category_content__3tj1f","header":"Category_header__2RI9e","location":"Category_location__2nmdS"};